"use strict";

var LoggerInstance = require("js-logger").get("CheckoutActions");

var CheckoutApi = require("./CheckoutApi");
var CheckoutStore = require("./CheckoutStore");

var CheckoutHelper = require("../commonComponents/CheckoutHelper");
var ShipToAccountHelper = require("../commonComponents/ShipToAccountHelper");
var SuggestedDonationHelper = require("../commonComponents/SuggestedDonationHelper");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var NumberHelper = require("../shared/NumberHelper");

var TaxHelper = {
	initializeTaxListeners: function() {
		this.updateTax();
		CheckoutStore.addShippingListener(this.updateTax);

		//If address changes, we need to recalculate
		//Create AccountForm
		var createAccountFormSelector = "#createAccountForm";
		$(`${createAccountFormSelector} input[data-component='accountAddressPostalCode'],${createAccountFormSelector} select[name='address.country']`).change(() => this.updateTax());
		//ShipTo For Gift Account
		var createGiftAccountFormSelector = "#createGiftAccountForm";
		$(`${createGiftAccountFormSelector} input[data-component='accountAddressPostalCode'],${createGiftAccountFormSelector} select[name='address.country']`).change(() => this.updateTax());
		//For shipToOtherAddress
		var otherAddressAddFormSelector = "#addOtherAddresses";
		$(`${otherAddressAddFormSelector} input[data-component='accountAddressPostalCode'],${otherAddressAddFormSelector} select[name='address.country']`).change(() => this.updateTax());

		//shipToComponent
		$("input[type='radio'][name='shipToAddressSelector']").change((event) => {
			if ($(event.currentTarget).is(":checked")) {
				this.updateTax();
			}
		});

		//Other Addresses
		$("[data-dynamic-href='cancelAddOtherAddress']").change(() => this.updateTax());
		$("input[type='radio'][name='otherAddressesSelector']").change((event) => {
			if ($(event.currentTarget).is(":checked")) {
				this.updateTax();
			}
		});

		$("body").one("mainProductQuantityMounted", () => {
			$("input.main-product-quantity").change(() => this.updateTax());
		});

		// This is used to manually trigger a tax lookup from the CheckoutStore after processing
		// a OPCO coupon. Because we can't reference it (circular dependency) we need to trigger.
		$("body").on("manuallyUpdateTax", () => {
			this.updateTax();
		});
	},

	updateTax: function() {
		var shippingAmount = CheckoutStore.getShippingAmount();

		//Try to get an address on the page, otherwise, try to get the shippingAddress, if they are logged in.
		var address = ShipToAccountHelper.getShippingAddress();

		var products = null;
		var singleProductCode = CheckoutStore.get("productCode");
		if (singleProductCode && !SuggestedDonationHelper.isOnePageSuggestedDonation()) {
			//If we are on a Product Page
			products = [
				{
					discountAmount: CheckoutStore.get("productDiscount"),
					isShippable: CheckoutStore.get("hasShippableProducts"),
					price: CheckoutStore.get("productPrice"),
					productCode: singleProductCode,
					quantity: $("input.main-product-quantity").val() || 1 //Cannot access ProjectStore because we are in the checkoutComponents bundle not commonComponents bundle
				}
			];
		}

		products = products || CheckoutStore.getCartProducts() || [];
		products = products.filter(product => !product.suggestedDonation);

		CheckoutHelper.getSubscriptionTaxControlRecord().done((useSubscriptionTax) => {
			CheckoutHelper.getShippingTaxId().done((shipTaxId) => {
				var subscriptions = CheckoutStore.getCartSubscriptions() || [];

				if (useSubscriptionTax != "Y") {
					//If subscription tax is turned off, we don't want to add it to the call
					subscriptions = [];
				}

				if (!products.length && !subscriptions.length) {
					LoggerInstance.debug("There are no products or subscriptions in which to calculate tax.");
					// We need to defer this call so that any pending dispatches are finished.
					_.defer(() => {
						Dispatcher.dispatch({
							actionType: Constants.TAX_UPDATED,
							taxAmount: 0
						});
					});
					return;
				}

				if (!address.id && (!address.postalCode || !address.country)) {
					//We do not have enough data to get the tax information
					//	we do not have an addressId and postalCode or country is not populated either.
					LoggerInstance.info("Tax cannot be calculated right now.");
					return;
				}

				var addressId = address.id;

				//Similar code for this is in Services StudioOnlineTransactionLogic.CalculateTaxAmount
				var taxDetails = products.map(product => {
					var extendedAmount = (product.price * (product.quantity || 1)) - (product.discountAmount || 0);
					return {
						product: product.productCode,
						totalAmount: extendedAmount,
						quantity: product.quantity
					};
				}).concat(
					subscriptions.map(subscription => {
						var extendedAmount = (subscription.price * (subscription.quantity || 1)) - (subscription.discountAmount || 0);

						return {
							subscription: subscription.subscriptionCode,
							totalAmount: extendedAmount,
							quantity: subscription.quantity,
							shipToAddressId: subscription.fulfillmentMethod == "MAIL" ? subscription.deliveryId : subscription.recipientAccountPrimaryAddressId
						};
					})
				);

				if (shippingAmount > 0) {
					taxDetails.push({
						product: shipTaxId,
						totalAmount: shippingAmount,
						quantity: 1
					});
				}

				var taxQuoteRequest = {
					details: taxDetails
				};

				if (addressId != null) {
					taxQuoteRequest.shipToAddressId = addressId;
				} else {
					taxQuoteRequest.shipTo = address;
				}

				if (_.isEqual(this.previousTaxQuoteRequest, taxQuoteRequest) && (CheckoutStore.get("taxAmount") != null || this.inProgress)) { //coercion because 0 taxAmount is valid.
					LoggerInstance.debug("We do not need to try to calculate tax because the request is the same as last time and we either have a tax amount or an API call is in progress.");
					return;
				}

				//Logging current request as previous and making note that a request is beginning
				this.previousTaxQuoteRequest = taxQuoteRequest;
				this.inProgress = true;

				LoggerInstance.info("Tax request in process.");
				CheckoutApi.getTaxQuote(taxQuoteRequest).done((data, textStatus, jqXHR) => {
					Dispatcher.dispatch({
						actionType: Constants.TAX_UPDATED,
						taxAmount: NumberHelper.roundToTwoDecimals(data.totalTaxAdded)
					});
					this.inProgress = false;
				}).fail((jqXHR, textStatus, errorThrown) => {
					Dispatcher.dispatch({
						actionType: Constants.TAX_UPDATE_FAILED,
						jqXHR
					});

					this.inProgress = false;
				});
			});
		});
	}
};

module.exports = TaxHelper;



// WEBPACK FOOTER //
// ./Javascript/checkoutComponents/TaxHelper.jsx